"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenType = void 0;
// Copyright 2017-2022 @darwinia/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
let TokenType;
exports.TokenType = TokenType;

(function (TokenType) {
  TokenType[TokenType["Ring"] = 0] = "Ring";
  TokenType[TokenType["Kton"] = 1] = "Kton";
})(TokenType || (exports.TokenType = TokenType = {}));